import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
  }
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const BannerTitle = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const BannerDescription = styled.p`
  margin: 8px 0 16px 0;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: max-content;
`;

export const BannerImage = styled.img`
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    width: 35%;
    align-self: center;
  }
`;
